import React from 'react';

const Events = () => {
  return (
    <div className="bg-white">
      <section className="my-12 bg-white">
        <h1 className="text-4xl p-8 font-bold text-center text-gray-900 md:text-5xl lg:text-6xl">Events</h1>
 <div className="flex justify-around text-xl  flex-wrap md:flex-row md:justify-around mb-4">

          {/* Division B */}
          <div className="w-full text-center my-8 md:w-1/2 lg:w-1/2 pr-4">
            <h2 className="text-2xl font-semibold mb-2">Division B</h2>
            <ul className="">
              <li>Anatomy and Physiology</li>
              <li>Boomilever (Trial)</li>
              <li>Circuit Lab</li>
              <li>Codebusters</li>
              <li>Crime Busters</li>
              <li>Disease Detectives</li>
              <li>Dynamic Planet</li>
              <li>Entomology</li>
              <li>Experimental Design</li>
              <li>Helicopter (Trial)</li>
              <li>Heredity</li>
              <li>Hovercraft (Trial)</li>
              <li>Machines</li>
              <li>Meteorology</li>
              <li>Metric Mastery</li>
              <li>Mission Possible (Trial)</li>
              <li>Potions and Poisons</li>
              <li>Remote Sensing</li>
              <li>Rocks and Minerals</li>
              <li>Scrambler (Trial)</li>
              <li>Solar System</li>
              <li>Water Quality</li>
              <li>Write It Do It</li>
            </ul>
          </div>

          {/* Division C */}
          <div className="w-full text-center my-8 md:w-1/2 lg:w-1/2 pr-4">
            <h2 className="text-2xl font-semibold mb-2">Division C</h2>
            <ul className="">
              <li>Anatomy and Physiology</li>
              <li>Astronomy</li>
              <li>Boomilever (Trial)</li>
              <li>Bungee Drop (Trial)</li>
              <li>Chemistry Lab</li>
              <li>Circuit Lab</li>
              <li>Codebusters</li>
              <li>Designer Genes</li>
              <li>Disease Detectives</li>
              <li>Dynamic Planet</li>
              <li>Electric Vehicle (Trial)</li>
              <li>Engineering CAD</li>
              <li>Entomology</li>
              <li>Experimental Design</li>
              <li>Forensics</li>
              <li>Helicopter (Trial)</li>
              <li>Hovercraft (Trail)</li>
              <li>Machines</li>
              <li>Materials Science</li>
              <li>Remote Sensing</li>
              <li>Robot Tour (Trial)</li>
              <li>Rocks and Minerals</li>
              <li>Water Quality</li>
            </ul>
          </div>

          </div>
     
      </section>
    </div>
  );
};

export default Events;
